import { motion } from 'framer-motion'
import { useScrollAnimation } from '../../hooks/useScrollAnimation'
import styles from './CTA.module.css'

export default function CTA() {
  const { ref, isVisible } = useScrollAnimation<HTMLElement>()

  return (
    <section className={styles.cta} ref={ref}>
      <div className={styles.content}>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={isVisible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
        >
          Ready to Build Production-Scale Agents?
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={isVisible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          Join thousands of developers building the next generation of AI applications with Luminox.
        </motion.p>
        <motion.div
          className={styles.buttons}
          initial={{ opacity: 0, y: 20 }}
          animate={isVisible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <motion.a
            href="https://github.com/luminox-mem/luminox"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary btn-large"
            whileHover={{
              scale: 1.05,
              boxShadow: '0 8px 40px rgba(255, 215, 0, 0.5)',
            }}
            whileTap={{ scale: 0.95 }}
          >
            View on GitHub
          </motion.a>
          <motion.a
            href="#quickstart"
            className="btn btn-secondary btn-large"
            whileHover={{
              scale: 1.05,
              borderColor: 'rgba(255, 215, 0, 0.5)',
            }}
            whileTap={{ scale: 0.95 }}
          >
            Get Started
          </motion.a>
        </motion.div>
      </div>

      {/* Animated background glow */}
      <motion.div
        className={styles.glow}
        animate={{
          opacity: [0.3, 0.5, 0.3],
          scale: [1, 1.1, 1],
        }}
        transition={{ duration: 4, repeat: Infinity }}
      />
    </section>
  )
}
